import {useRouter} from 'next/router';
import PropTypes from 'prop-types';
import {pathOr} from 'ramda';

import {SEARCH_TYPE} from '@/src/app/constants/search';
import useTargetUserActions from '@/src/app/store/targetUser/useTargetUserActions';
import {LocationTypes} from '@/src/hooks/useCountriesList';
import useTargetClinic from '@/src/profile/clinicTarget/hooks/useTargetClinic';
import FilterRow from '@/src/Search/components/FilterRow';
import SortingFilters from '@/src/Search/components/SortingFilters';
import UsersTypeFilter from '@/src/Search/components/UsersTypeFilter';
import CitiesCheckboxesFilter from '@/src/Search/containers/CitiesCheckboxesFilter';
import {useSearchFilters} from '@/src/Search/utils/useSearchFilters';

import css from '../styles/FilterRow.module.css';

const getLocationType = (slug) => {
  switch (slug) {
    case SEARCH_TYPE.FOLLOWERS:
      return LocationTypes.WITH_FOLLOWERS;
    case SEARCH_TYPE.FOLLOWING:
      return LocationTypes.WITH_FOLLOWING;
    default:
      return LocationTypes.WITH_USERS;
  }
};

const UsersFilter = ({setQueryFilters, userType}) => {
  const {query} = useRouter();
  const {targetUser} = useTargetUserActions();
  const {clinic} = useTargetClinic();
  const {onMultipleFilterClickHandle} = useSearchFilters(userType);

  const userId = pathOr(null, ['user', 'id'], targetUser);
  const clinicId = pathOr(null, ['data', 'user_id'], clinic);

  return (
    <>
      <div className={css.withUnderline}>
        <FilterRow>
          <SortingFilters
            query={query}
            setQueryFilters={setQueryFilters}
            withPopular={false}
          />
        </FilterRow>
      </div>
      <div className={css.withUnderline}>
        <FilterRow>
          <UsersTypeFilter
            query={query}
            onChangeHandler={onMultipleFilterClickHandle}
            withoutClinic={
              query.slug === SEARCH_TYPE.EMPLOYEES ||
              query.slug === SEARCH_TYPE.ALL_CANDIDATES ||
              query.slug === SEARCH_TYPE.USERS
            }
          />
        </FilterRow>
      </div>

      <div className={css.withUnderline}>
        <FilterRow>
          <CitiesCheckboxesFilter
            locationType={getLocationType(query.slug)}
            userType={userType}
            userId={userId || clinicId}
          />
        </FilterRow>
      </div>
    </>
  );
};

UsersFilter.propTypes = {
  setQueryFilters: PropTypes.func.isRequired,
  userType: PropTypes.string,
};

export default UsersFilter;
